import React from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  MdDashboard,
  MdPeople,
  MdSettings,
  MdLogout,
  MdDescription,
  MdMessage,
  MdEvent,
} from "react-icons/md";

import FullLogo from "../../assets/fullLogo.svg";
import { useAuth } from "../../context/AuthContext";
import { api } from "../../api/axios";

const Sidebar = () => {
  const navigate = useNavigate();
  const { role} = useAuth();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("token_expires");

    navigate("/");
  };

  return (
    <aside className="w-64 bg-[#95785A] text-white flex flex-col">
      {/* LOGO */}
      <div className="h-16 flex items-center justify-center border-b border-white/20 px-4">
        <Link to="/">
          <img
            src={FullLogo}
            alt="Admin Logo"
            className="h-10 object-contain"
          />
        </Link>
      </div>

      {/* NAVIGATION */}
      <nav className="flex-1 px-4 py-6 space-y-1">
        {/* DASHBOARD – all */}
        <button
          onClick={() => navigate("/dashboard")}
          className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left hover:bg-white/20 transition"
        >
          <MdDashboard size={20} />
          <span>Dashboard</span>
        </button>

        {/* USERS – SuperAdmin only */}
        {role === "SuperAdmin" && (
          <button
            onClick={() => navigate("/dashboard/users")}
            className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left hover:bg-white/20 transition"
          >
            <MdPeople size={20} />
            <span>Users</span>
          </button>
        )}

        {/* CONTENT – SuperAdmin, Admin, Editor */}
        {(role === "SuperAdmin" ||
          role === "Admin" ||
          role === "Editor") && (
          <button
            onClick={() => navigate("/dashboard/content")}
            className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left hover:bg-white/20 transition"
          >
            <MdDescription size={20} />
            <span>Content</span>
          </button>
        )}

        {/* BOOKINGS – SuperAdmin, Admin */}
        {(role === "SuperAdmin" || role === "Admin") && (
          <button
            onClick={() => navigate("/dashboard/bookings")}
            className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left hover:bg-white/20 transition"
          >
            <MdEvent size={20} />
            <span>Bookings</span>
          </button>
        )}

           {(role === "SuperAdmin" || role === "Admin") && (
          <button
            onClick={() => navigate("/dashboard/contactmessages")}
            className="flex w-full items-center gap-3 rounded-lg px-4 py-2 text-left hover:bg-white/20 transition"
          >
            <MdMessage size={20} />
            <span>Messages</span>
          </button>
        )}

  
      </nav>

      {/* LOGOUT */}
      <div className="px-4 py-4 border-t border-white/20">
        <button
          onClick={handleLogout}
          className="flex w-full items-center justify-center gap-3 rounded-lg bg-white py-2 font-semibold text-[#95785A] hover:opacity-90 transition"
        >
          <MdLogout size={20} />
          Logout
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
